export const FAKE_SELECTS_SELECTOR = '.js-fake-select';